const updateInterval = 1800000;
const state = {
  products: [],
  fetchedAt: 0,
  updateInterval: updateInterval
};
const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
    state.fetchedAt = Date.now();
  }
};
const actions = {
  setProducts(context, products) {
    context.commit("SET_PRODUCTS", products);
  }
};
const getters = {
  getProducts(state) {
    return state;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
